import { render, staticRenderFns } from "./data-location-flags.vue?vue&type=template&id=1d2f86b7&scoped=true"
import script from "./data-location-flags.vue?vue&type=script&lang=js"
export * from "./data-location-flags.vue?vue&type=script&lang=js"
import style0 from "./data-location-flags.vue?vue&type=style&index=0&id=1d2f86b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f86b7",
  null
  
)

export default component.exports